module.exports = __webpack_public_path__ + "img/price-bg.5a778b01.png";